module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sheila Walsh, Sherri Gragg\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Sheila Walsh is a powerful communicator, Bible teacher, and bestselling author with almost six million books sold. She is the author of the award-winning Gigi, God’s Little Princess series, "), _c('I', [_vm._v("It’s Okay Not to Be Okay")]), _vm._v(", "), _c('I', [_vm._v("Praying Women")]), _vm._v(", "), _c('I', [_vm._v("Holding On When You Want to Let Go")]), _vm._v(", and more. She is cohost of the inspirational talk show "), _c('I', [_vm._v("Life Today")]), _vm._v(" with James and Betty Robison, which is seen worldwide by a potential audience of over 100 million viewers. Sheila lives in Dallas, Texas, with her husband, Barry, and son, Christian, who is in graduate school.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LPAtfC/images/cover.jpg?1742002746599",
      "alt": "This image is the cover for the book 5 Minutes with Jesus: Quiet Time for Your Soul, 5 Minutes with Jesus"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("5 Minutes with Jesus: Quiet Time for Your Soul, 5 Minutes with Jesus\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("Five Minutes with Jesus")]), _vm._v(" provides bursts of inspiration for every reader’s relationship with Jesus. Brief but profound, these daily readings from Sheila Walsh will help busy people draw close to Him and walk with Him throughout the day. It will become clear that, even in the midst of a busy lifestyle, every minute we spend in the powerful presence of Jesus makes a difference in our lives!")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0